import { AppointmentDetailDialog } from "@/domains/appointment/appointments/components/appointment-detail-dialog/appointment-detail-dialog";
import { CreateAppointmentDialog } from "@/domains/appointment/appointments/components/create/create-appointment-dialog";
import { OverCapacityDialog } from "@/domains/appointment/appointments/components/dialogs/over-capacity-dialog";
import { useDialogRouterSimple as useDialogRouter } from "@/lib/dialog/use-dialog-router-simple";

/**
 * Global dialog provider that renders all application dialogs
 * based on the current dialog router state
 */
export function GlobalDialogProvider() {
  const { isDialogOpen, getDialogConfig, closeDialog } = useDialogRouter();

  return (
    <>
      {/* Appointment Detail Dialog */}
      <AppointmentDetailDialog
        appointmentId={getDialogConfig("appointment-detail")?.id || null}
        open={isDialogOpen("appointment-detail")}
        onClose={() => closeDialog("appointment-detail")}
      />

      {/* Create Appointment Dialog */}
      <CreateAppointmentDialog
        open={isDialogOpen("appointment-create")}
        onOpenChange={(open) => {
          if (!open) {
            closeDialog("appointment-create");
          }
        }}
        prefilledData={{
          customerId: (() => {
            const config = getDialogConfig("appointment-create");
            return config?.type === "appointment-create" ? config.params?.customerId : undefined;
          })(),
        }}
      />

      <OverCapacityDialog />
    </>
  );
}
